export default class PlaceholderCodeEditor {

}